import { render } from "./FormPruefprotokoll_SPIConnect.vue?vue&type=template&id=6ac33436&scoped=true"
import script from "./FormPruefprotokoll_SPIConnect.vue?vue&type=script&lang=js"
export * from "./FormPruefprotokoll_SPIConnect.vue?vue&type=script&lang=js"

import "./FormPruefprotokoll_SPIConnect.vue?vue&type=style&index=0&id=6ac33436&lang=scss&scoped=true"

import exportComponent from "/home/hiro/lab/hands4you-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ac33436"]])

export default __exports__